// components/About/About.jsx
import React, { useEffect } from 'react';
import './About.css';

const About = () => {
  useEffect(() => {
    // Animate elements on scroll
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observe all about cards
    document.querySelectorAll('.about-card').forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(card);
    });

    return () => {
      document.querySelectorAll('.about-card').forEach(card => {
        observer.unobserve(card);
      });
    };
  }, []);

  return (
    <section id="nosotros" className="section">
      <h2>NOSOTROS</h2>
      <div className="about-grid">
      <div className="about-card">
          <h3>Nuestra Historia</h3>
          <p>Con más de 10 años de trayectoria, DB Alambrados nació como un emprendimiento familiar con el propósito de cubrir una necesidad concreta: ofrecer cercos de calidad, duraderos y accesibles. A lo largo de los años, crecimos en escala, incorporamos tecnología, desarrollamos nuevos productos como postes de hormigón y césped sintético, y consolidamos un equipo comprometido con cada obra. Hoy, seguimos apostando al trabajo bien hecho, con atención personalizada y una mirada puesta en el futuro.</p>
        </div>
        <div className="about-card">
          <h3>Nuestra Visión</h3>
          <p>Ser referentes regionales en infraestructura perimetral, destacándonos por la calidad de nuestros productos, la eficiencia del servicio y la confianza que generamos en nuestros clientes. Buscamos crecer junto a quienes nos eligen, aportando valor desde la experiencia y la mejora continua.</p>
        </div>
        <div className="about-card">
          <h3>Nuestra Misión</h3>
          <p>Brindar soluciones integrales para cercos perimetrales, ofreciendo productos de calidad como postes de hormigón, tejidos, portones y césped sintético, acompañados de un servicio completo que incluye instalación, flete, asesoramiento, gerenciamiento de obra y postventa. Nos enfocamos en garantizar seguridad, funcionalidad y estética en cada proyecto.</p>
        </div>
        
      </div>
    </section>
  );
};

export default About;